import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
/** The `TitleField` is the template to use to render the title of a field
 *
 * @param props - The `TitleFieldProps` for this component
 */
export default function TitleField({ id, title, }) {
    return (_jsxs(Box, Object.assign({ id: id, mb: 1, mt: 1 }, { children: [_jsx(Typography, Object.assign({ variant: 'h5' }, { children: title })), _jsx(Divider, {})] })));
}
//# sourceMappingURL=TitleField.js.map